import React from 'react';
import { Container, Row, Col } from 'react-bootstrap'
import DefaultLayout from '../../layouts/Default'
import BjjImage from '../../assets/images/bio-bjj.jpg'
import JapaneseImage from '../../assets/images/bio-japanese.jpg'

const Bio = () => {
  return (
    <DefaultLayout pageTitle="play">
      <Container>
        <Row>
          <Col>
              <img className="bio__image" src={BjjImage} alt="receiving my third in jiu-jitsu"/>
              <caption>BJJ - Receiving my 3rd stripe (white belt)</caption>
          </Col>
        </Row>
        <Row>
          <Col>
              <img className="bio__image" src={JapaneseImage} alt="my japansese classmates"/>
              <caption>Japanese - Currently N4 (intermediate). I have met so many awesome people over the past 4 years.</caption>
          </Col>
        </Row>

        {/* <Row>
          <Col>
              <iframe className="video" width="560" height="500" src="https://www.youtube.com/embed/pGl7ECz6De8?si=n7W73X2DWaobHhZk" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
              <caption>[EXPLICIT] Video editing has always been my first love. Here’s a recent project I put together for Tampa Street Cars — one of the fastest-growing car enthusiast communities in the area.</caption>
          </Col>
        </Row> */}
      </Container>
    </DefaultLayout>
  )
}

export default Bio;
